/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplaceLegalAgreementDraftContentRequest
 */
export interface ReplaceLegalAgreementDraftContentRequest {
    /**
     * Full replacement map of language to content (HTML).
     * Keys must be valid LegalAgreementLanguage values.
     * Missing language keys remove existing draft content for these languages.
     * HTML is stored as authored by Malt admins. User-facing rendering must sanitize or isolate this HTML before injecting it into the DOM.
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ReplaceLegalAgreementDraftContentRequest
     */
    contents: { [key: string]: string; };
}

/**
 * Check if a given object implements the ReplaceLegalAgreementDraftContentRequest interface.
 */
export function instanceOfReplaceLegalAgreementDraftContentRequest(value: object): value is ReplaceLegalAgreementDraftContentRequest {
    if (!('contents' in value) || value['contents'] === undefined) return false;
    return true;
}

export function ReplaceLegalAgreementDraftContentRequestFromJSON(json: any): ReplaceLegalAgreementDraftContentRequest {
    return ReplaceLegalAgreementDraftContentRequestFromJSONTyped(json, false);
}

export function ReplaceLegalAgreementDraftContentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceLegalAgreementDraftContentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contents': json['contents'],
    };
}

export function ReplaceLegalAgreementDraftContentRequestToJSON(value?: ReplaceLegalAgreementDraftContentRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contents': value['contents'],
    };
}

